import { useRef, useEffect, useState, useMemo } from 'react';
import { useSelector } from "react-redux";
import { RootState } from '../redux/store';
import {  useMediaQuery, useTheme } from "@material-ui/core";

export function useInterval(callback, delay) {
  const savedCallback = useRef<Function>();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current && savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export function useSearchPosts(dataArray: any[]) {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredResults = useMemo(() => {
    if (!dataArray || !Array.isArray(dataArray) || dataArray?.length === 0) return [];

    if(!searchQuery)
    { 

      return dataArray
    }

    const results = dataArray?.filter((item) =>
      item?.data?.title?.toLowerCase().includes(searchQuery.toLowerCase())
    );
    return results;


  }, [searchQuery, dataArray]);

  return { searchQuery, setSearchQuery, filteredResults };
}

export function useSearchCommunity() {
  const { singleProgram } = useSelector((state: RootState) => state.programReducer);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredCommunities = singleProgram?.communities?.filter((community) =>
    community.communityName.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  return { searchQuery, setSearchQuery, filteredCommunities };
}

export function useSearchChannels(dataArray: any[]) {
  const [searchQuery, setSearchQuery] = useState("");
  const filteredResults = dataArray?.filter(
    (channel) =>
      channel.channelIdentifier.toLowerCase().includes(searchQuery.toLowerCase()) ||
      channel.channelName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  return { searchQuery, setSearchQuery, filteredResults };
}

export function useIsMobile(): boolean {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return isMobile;
}

export function useChannelPost(channelIdentifier:string){
  const { programChannelPost } = useSelector((state: RootState) => state.programReducer);
  return programChannelPost?.[channelIdentifier]||[]
}




const hooks = { useInterval, useSearchPosts, useSearchCommunity, useSearchChannels, useIsMobile, useChannelPost};
export default hooks;